import React from 'react';
import { TrustBar } from './components/TrustBar';
import { HeroSection } from './components/HeroSection';
import { GalleryMarquee } from './components/GalleryMarquee';
import { LetterSection } from './components/LetterSection';
import { ProblemSection } from './components/ProblemSection';
import { TestimonialSection } from './components/TestimonialSection';
import { SolutionSection } from './components/SolutionSection';
import { MechanismSection } from './components/MechanismSection';
import { FeaturesSection } from './components/FeaturesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FooterCTA } from './components/FooterCTA';
import { WhatsAppButton } from './components/WhatsAppButton';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <main className="min-h-screen bg-[#020202] text-white selection:bg-purple-500/30" data-id="element-0">
      <TrustBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <GalleryMarquee data-id="element-3" />
      <LetterSection data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <TestimonialSection data-id="element-6" />
      <SolutionSection data-id="element-7" />
      <MechanismSection data-id="element-8" />
      <FeaturesSection data-id="element-9" />
      <BonusSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FooterCTA data-id="element-14" />

      <WhatsAppButton data-id="element-15" />
      <StickyMobileCTA data-id="element-16" />
    </main>;
}